













import { Component, Vue, Prop } from "vue-property-decorator";
import envLoader from "shared/env-loader";

@Component
export default class DownloadButton extends Vue {
  @Prop({ required: true, type: String }) public url!: string;
  @Prop({ type: String, default: "Download" }) public label!: string;

  get downloadLink() {
    let base = envLoader("API_URL", this.location);
    base += base.endsWith("/") ? "" : "/";
    return base + this.url;
  }

  get location() {
    return (
      location.protocol +
      "//" +
      location.hostname +
      (location.port ? ":" + location.port : "")
    );
  }
}
